export default "/images/vendor/flag-icon-css/flags/1x1/ni.svg?52cfeebfb0f78f395c1380c208ae088d";